export default __webpack_public_path__ + "fonts/Roboto-400-greek-ext10.woff2";